import styled from 'styled-components'
import { HTMLAttributes } from 'react'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    position: relative;
    height: 2.375rem;
    border: 2px solid ${ThemeColors.getGreenColor()};
    display: flex;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    outline: none;
    -webkit-appearance: none;
    border-radius: 7px;
    width: 100%;
`
export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: 0.2rem;
`
export const InputContainer = styled.div`
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
    border-radius: 7px;

    & input {
        border-radius: 7px;
    }
`
export const ButtonSearch = styled.button`
    background-color: ${ThemeColors.getGreenColor()};
    color: ${ThemeColors.white};
    padding: 0.2rem;
    border: 0;
    height: 100%;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
`

export const CancelButtonContainer = styled.div`
    height: 100%;
    padding: 0.2rem;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
`
export const CancelButton = styled.button`
    box-shadow: none;
    outline: none;
    margin: 0;
    background-color: inherit;
    border: none;
    cursor: pointer;
    -webkit-appearance: none;
    height: 1.2em;
    width: 1.2em;
    background: ${`url('${process.env.NEXT_PUBLIC_BASE_PATH}/images/close-mobile-gray.svg')`} no-repeat 50% 50%;
    background-size: contain;
    pointer-events: none;
    display: flex;
    align-items: center;
`

export const Input = styled.input<HTMLAttributes<HTMLInputElement>>`
    width: 100%;
    padding: 0.2rem 0;
    font-size: 1.25rem;
    height: 100%;
    color: ${ThemeColors.getGrayColor(0.7)};
    border: none;
    -webkit-appearance: none;
    appearance: none;
    outline: none;
    position: relative;
    box-sizing: border-box;

    &:focus {
        outline: none;
    }

    &::-webkit-search-cancel-button {
        -webkit-appearance: none;
        height: 1em;
        width: 1em;
        background: ${`url('${process.env.NEXT_PUBLIC_BASE_PATH}/images/close-mobile-gray.svg')`} no-repeat 50% 50%;
        background-size: contain;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 3px;
        display: flex;
        align-items: center;
        top: 0.45rem;
    }

    &:focus::-webkit-search-cancel-button {
        opacity: 1;
        pointer-events: all;
    }
`
